import React, { useState } from "react";
import { Helmet } from "react-helmet";
import AdminHeader from "./../layouts/AdminHeader";
import AdminSider from "./../layouts/AdminSider";
import Content from "../sections/listing-details-v1/Content";

const AdminPropertyDetail = (props) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  return (
    <div>
      <Helmet>
        <title>
          Buy Home For Less | Admin Property Detail
        </title>
        <meta name="description" content="#" />
      </Helmet>
      <AdminHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
      <div style={{ display: "flex" }}>
        <AdminSider
          url={props.url}
          collapsed={collapsed}
          toggleCollapsed={toggleCollapsed}
        />
        <div style={{ flex: 1, padding: "20px",overflowX:"auto" }}>
          <div className="text-center" style={{ margin: "20px" }}>
            <h2>Property Detail</h2>
          </div>
          <Content />
        </div>
      </div>
    </div>
  );
};

export default AdminPropertyDetail;
